// How did the user apply?
export enum ApplicationMethod {
	Redirect = "Redirect",
	FormSubmission = "Form submission",
	DirectApply = "Direct Apply"
}

// Where did the user apply?
export enum ApplicationLocation {
	FavouritePage = "Favourite page",
	ResultsPage = "Results page",
	SingleResultPage = "Single result page",
	CompanyPage = "Company page",
	ShortPage = "Short page"
}

// Define the event data structure
export interface ApplicationEvent {
	distinct_id: string;
	job_uuid: string;
	company_uuid: string;
	application_method: ApplicationMethod;
	application_location: ApplicationLocation;
}
